import {SafeReadonly} from '@apollo/client/cache/core/types/common';
import {FieldFunctionOptions} from '@apollo/client/cache/inmemory/policies';

export const fieldPolicy =
  (typename: string, idField = 'id') =>
  (existing: SafeReadonly<any> | undefined, {args, toReference}: FieldFunctionOptions) => {
    return toReference({
      __typename: typename,
      id: args?.[idField]
    });
  };
